import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThreadViewModel } from '../../models';
import { Group } from '@anecdotes/utils';

@Component({
  selector: 'app-thread-group-view',
  templateUrl: './thread-group-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadGroupViewComponent {
  @Input()
  threadGroup: Group<string, ThreadViewModel>;
}
